export var UserType;
(function (UserType) {
    UserType["FREDDER"] = "FREDDER";
    UserType["MANFREDITE"] = "MANFREDITE";
    UserType["COMPANY"] = "COMPANY";
})(UserType || (UserType = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING"] = "PENDING";
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["DISABLED"] = "DISABLED";
})(UserStatus || (UserStatus = {}));
//# sourceMappingURL=users.interface.js.map